var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footnote-text"},[_vm._v(" "+_vm._s(_vm.labels.foot_note.biggest_outlet_explanation)+" "),_c('br'),_vm._v(" "+_vm._s(_vm.labels.foot_note.more_information)+" "),_c('a',{attrs:{"href":_vm.auszeichnungenLink,"target":"_blank","rel":"noopener"}},[_vm._v(_vm._s(_vm.auszeichnungenLink))])])
}
var staticRenderFns = []

export { render, staticRenderFns }